import { memo } from 'react'
import { dispatch } from 'store'
import {
  ButtonWithIcon as StyledButtonWithIcon,
  EmptyTrack as StyledEmptyTrack
} from '../../styled'
import AudioIcon from 'assets/svgr-icons/Audio.svg'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { AUDIO_TRACK_HEIGHT } from '../consts'
import { SUB_SIDEBAR_KEYS } from 'consts/sidebar'
import { T } from 'consts/translationKeys'

import { editorThunks } from 'store/features/editor/thunks'
import { useResponsive } from 'hooks/useResponsive'
import { translate } from 'utils/translations'

const EmptyTrack = () => {
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  const handleAddAudioClick = () => {
    dispatch(
      editorThunks.setActiveSidebarTabAndCloseOverlay(SUB_SIDEBAR_KEYS.AUDIO)
    )

    if (isMobile) {
      dispatch(editorThunks.setIsMobileSubSidebarOpen(true))
    }
  }

  return (
    <StyledEmptyTrack $height={AUDIO_TRACK_HEIGHT}>
      <StyledButtonWithIcon onClick={handleAddAudioClick}>
        <AudioIcon />
        <span>{translate(T.ADD_AUDIO_LABEL)}</span>
      </StyledButtonWithIcon>
    </StyledEmptyTrack>
  )
}

export default memo(EmptyTrack)
